import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Para qué edad es el sistema?',
  a: 'El MegaPack está diseñado para niños de 6 a 10 años. Es el rango donde las dificultades lectoras son más corregibles y donde la intervención tiene mayor impacto.'
}, {
  q: '¿Necesito ser maestro para aplicarlo?',
  a: 'No. Está diseñado específicamente para padres sin formación docente. Cada ejercicio tiene instrucciones paso a paso.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Es 100% digital. Inmediatamente después de tu compra recibís un email con el enlace de descarga de todos los PDFs.'
}, {
  q: '¿Puedo imprimirlo?',
  a: 'Sí. Todos los PDFs están diseñados para ser impresos en formato A4 estándar.'
}, {
  q: '¿Mi hijo tiene que tener diagnóstico de dislexia?',
  a: 'No. El sistema trabaja con cualquier tipo de dificultad lectora — silabeo, falta de fluidez, falta de comprensión.'
}, {
  q: '¿Cuál es la diferencia real entre el Plan Base y el Plan Premium?',
  a: 'El Plan Base te da el sistema completo. El Plan Premium agrega el Kit Acelerador — materiales listos para usar desde el día 1 sin preparar nada.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-12 md:py-16 bg-white" data-id="element-87">
      <div className="container mx-auto px-4 max-w-2xl" data-id="element-88">
        <h2 className="text-2xl font-bold text-navy text-center mb-8" data-id="element-89">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>
        <div className="space-y-3" data-id="element-90">
          {faqs.map((faq, i) => <div key={i} className="border-b border-slate-200" data-id="element-91">
              <button className="w-full py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-92">
                <span className="font-bold text-slate-700 text-sm" data-id="element-93">
                  {faq.q}
                </span>
                <ChevronDown className={`w-4 h-4 text-slate-400 transition-transform ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-94" />
              </button>
              <AnimatePresence data-id="element-95">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} data-id="element-96">
                    <div className="pb-4 text-sm text-slate-600" data-id="element-97">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}